import { render } from "./PhotoGallery.vue?vue&type=template&id=a4f481d6&scoped=true"
import script from "./PhotoGallery.vue?vue&type=script&lang=js"
export * from "./PhotoGallery.vue?vue&type=script&lang=js"

import "./PhotoGallery.vue?vue&type=style&index=0&id=a4f481d6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4f481d6"]])

export default __exports__